import React from "react";
import { useTranslation } from "react-i18next";

const Banner = () => {
    const { t } = useTranslation();
    const lang = localStorage.getItem("lang") || "en";
    return (
        <>
            <section id="home_one_banner">
                <div className="container mx-auto max-w-[1440px] px-4 py-3 md:py-3">
                    <div className="row align-items-center">
                        <div className="col-lg-12 ">
                            <div
                                className={
                                    lang === "ar" ? `text-end ` : `text-start`
                                }
                            >
                                {lang === "ar" ? (
                                    <h1 className="text-white ">
                                        أفضل الذكريات  <br />تبدأ{" "}
                                        <span className="s-link">هنا</span>
                                    </h1>
                                ) : lang === "fr" ? (
                                    <h1 className="text-white">
                                        LES MEILLEURS SOUVENIRS <br /> COMMENCENT{" "}
                                        <span className="s-link">ICI</span>
                                    </h1>
                                ) : (
                                    <h1 className="text-white">
                                        THE BEST MEMORIES <br />
                                        START{" "}
                                        <span className="s-link">HERE</span>
                                    </h1>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Banner;
